export const MEMBERSHIP_BRAND_ID_ENUMS = {
  FABLETICS: 1,
  YITTY: 2,
};
